import React from 'react';
import { Field, FieldProps } from 'formik';
import _ from 'lodash';

import { ValidationSchema, getRequiredFieldState } from 'helpers/form';
import TextInput, { TextProps } from './Text';

type TextFieldMapperProps = TextFieldProps & FieldProps<string>;

const TextFieldMapper = ({
  field,
  // the form and meta props from formik don't need to be passed to the TextInput component
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  form,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  meta,
  showRequiredFields,
  validationSchema,
  required,
  ...rest
}: TextFieldMapperProps) => {
  const isRequired = getRequiredFieldState({
    fieldName: field.name,
    showRequiredFields,
    required,
    validationSchema
  });

  return <TextInput formik {...field} {...rest} required={isRequired} />;
};

/*
 * [TextField] - wraps the Text component so that it can be used within Formik context
 */

interface TextFieldProps extends TextProps {
  showRequiredFields?: boolean;
  validationSchema?: ValidationSchema;
}

const TextField = (props: TextFieldProps) => {
  // in the pass we auto-generated the input name from the label.  To support this,
  // we've included this logic here, as well as in the base Text component
  const inputName = props.name || _.snakeCase(props.label?.toLowerCase());

  return (
    <Field
      {...props}
      component={TextFieldMapper}
      name={inputName}
      data-testid={inputName}
    />
  );
};

export default TextField;
